export default {
    namespaced: true,
    state: {
        template: null,
    },
    actions: {
        getTheme: async function ({ commit, dispatch }) {
            let response = await axios.get("/api/temas/predeterminado");
            if(response){
                let decode = response.decode??response;
                if (decode.data) {
                    commit("setData", { data: decode.data });
                }
            }
        },
    },
    mutations: {
        setData(state, payload) {
            if (payload.data != undefined) {
                state.template = payload.data;
            }
        },
    },
};
